module.exports = __webpack_public_path__ + "static/design-pc-4-fa6faffda0879760fe4e925f2d8043eb.png";